class CTImage extends HTMLElement {
    constructor() {
        super();

        this.querySelectorAll('.ct-image__read-more').forEach((element) => {            
            element.addEventListener('click', (e) => {
                const popup = e.target.nextElementSibling;
                popup.classList.add('ct-image__popup--active');  
            });
        });

        this.querySelectorAll('.ct-image__popup').forEach((element) => {
            element.addEventListener('click', (e) => {
                const popup = e.target.closest('.ct-image__popup');
                popup.classList.remove('ct-image__popup--active');  
            });
        });
        
    }


}

customElements.define('ct-image', CTImage);


